export const getApiUrl = () => {
  const envUrl = process.env.REACT_APP_API_URL;
  if (envUrl) return envUrl;

  if (typeof window !== 'undefined') {
    const { hostname, protocol, host } = window.location;

    // Local dev: fall back to local API server
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return process.env.REACT_APP_LOCAL_API_URL || 'https://clearance-scouts-server.onrender.com';
    }

    // Production: same-origin (e.g., https://firesales.app or your Heroku URL)
    return `${protocol}//${host}`;
  }

  // Fallback (SSR or unknown environment)
  return process.env.REACT_APP_API_URL || process.env.REACT_APP_LOCAL_API_URL || 'https://clearance-scouts-server.onrender.com';
};


